<span class="indicator-badge" [ngStyle]="addIndicatorStylesCallBack()">{{text}}</span>
